module.exports = __webpack_public_path__ + "static/media/loader.7dd5bcb3.gif";